import { render, staticRenderFns } from "./AllCandidates.vue?vue&type=template&id=6e50a147&scoped=true"
import script from "./AllCandidates.vue?vue&type=script&lang=ts"
export * from "./AllCandidates.vue?vue&type=script&lang=ts"
import style0 from "./AllCandidates.vue?vue&type=style&index=0&id=6e50a147&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e50a147",
  null
  
)

export default component.exports